export enum ClinicianWeeklyDataType{
    SideEffects=1, 
    TargetSymptoms=2,
    Ranking=3,
    AddImprovements=4,
    AddVisitDate=5,
    TargetOneAlias=6
}